class c extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const t = this.querySelector(".minus"),
      e = this.querySelector(".plus"),
      n = this.querySelector(".quantity");
    t == null || t.addEventListener("click", () => this.adjustQuantity(n, -1)),
      e == null || e.addEventListener("click", () => this.adjustQuantity(n, 1));
  }
  adjustQuantity(t, e) {
    const s = parseInt(t.value, 10) + e;
    s >= parseInt(t.min, 10) && (t.value = s.toString());
  }
}
customElements.define("uwp-quantity-selector", c);
